module.exports = __webpack_public_path__ + "img/31.19956323.gif";